// Registered app tours (KB loader home until ingest lands).

import { LEAD_CAPTURE_TOUR } from "./tours/leadCapture";
import { OPPORTUNITIES_ENTRY_TOUR } from "./tours/opportunitiesEntry";
import { SALES_CONSOLE_TOUR } from "./tours/salesConsole";
import { ADS_ASSISTANT_TOUR } from "./tours/adsAssistant";
import { CRM_HANDOFF_TOUR } from "./tours/crmHandoff";
import { TRAINING_PRACTICE_TOUR } from "./tours/trainingPractice";
import { SALES_INTAKE_TOUR } from "./tours/salesIntake";
import { FORMS_FORMATS_TOUR } from "./tours/formsFormats";
import { FULFILLMENT_INVENTORY_TOUR } from "./tours/fulfillmentInventory";
import { FULFILLMENT_INTAKE_TOUR } from "./tours/fulfillmentIntake";
import { KNOWLEDGEBASE_TOUR } from "./tours/knowledgebase";
import { KB_AUTHOR_TOUR } from "./tours/kbAuthor";
import { LOCATION_TOOLS_TOUR } from "./tours/locationTools";
import { AI_PROMPTING_TOUR } from "./tours/aiPrompting";
import { TRAINING_AUTHOR_TOUR } from "./tours/trainingAuthor";
import { ADS_GUIDANCE_TOUR } from "./tours/adsGuidance";
import { ADMIN_ORG_TOUR } from "./tours/adminOrg";
import { ADMIN_MEMBERS_TOUR } from "./tours/adminMembers";
import { MFG_INVENTORY_TOUR } from "./tours/mfgInventory";
import { MFG_PLANTS_UNITS_TOUR } from "./tours/mfgPlantsUnits";
import { OPS_PAPERWORK_TOUR } from "./tours/opsPaperwork";
import { RTO_TERMS_TOUR } from "./tours/rtoTerms";
import { LOGISTICS_ROUTES_TOUR } from "./tours/logisticsRoutes";
import { LOGISTICS_CARRIERS_TOUR } from "./tours/logisticsCarriers";
import { PLATFORM_HOME_TOUR } from "./tours/platformHome";
import type { FireflyTourArtifact } from "./tourTypes";

export { LEAD_CAPTURE_TOUR, LEAD_CAPTURE_TOUR_ID } from "./tours/leadCapture";
export {
  OPPORTUNITIES_ENTRY_TOUR,
  OPPORTUNITIES_ENTRY_TOUR_ID,
} from "./tours/opportunitiesEntry";
export { SALES_CONSOLE_TOUR, SALES_CONSOLE_TOUR_ID } from "./tours/salesConsole";
export { ADS_ASSISTANT_TOUR, ADS_ASSISTANT_TOUR_ID } from "./tours/adsAssistant";
export { CRM_HANDOFF_TOUR, CRM_HANDOFF_TOUR_ID } from "./tours/crmHandoff";
export {
  TRAINING_PRACTICE_TOUR,
  TRAINING_PRACTICE_TOUR_ID,
  TRAINING_TOUR,
  TRAINING_TOUR_ID,
} from "./tours/trainingPractice";
export { SALES_INTAKE_TOUR, SALES_INTAKE_TOUR_ID } from "./tours/salesIntake";
export { FORMS_FORMATS_TOUR, FORMS_FORMATS_TOUR_ID } from "./tours/formsFormats";
export {
  FULFILLMENT_INVENTORY_TOUR,
  FULFILLMENT_INVENTORY_TOUR_ID,
} from "./tours/fulfillmentInventory";
export { FULFILLMENT_INTAKE_TOUR, FULFILLMENT_INTAKE_TOUR_ID } from "./tours/fulfillmentIntake";
export { KNOWLEDGEBASE_TOUR, KNOWLEDGEBASE_TOUR_ID } from "./tours/knowledgebase";
export { KB_AUTHOR_TOUR, KB_AUTHOR_TOUR_ID } from "./tours/kbAuthor";
export { LOCATION_TOOLS_TOUR, LOCATION_TOOLS_TOUR_ID } from "./tours/locationTools";
export { AI_PROMPTING_TOUR, AI_PROMPTING_TOUR_ID } from "./tours/aiPrompting";
export { TRAINING_AUTHOR_TOUR, TRAINING_AUTHOR_TOUR_ID } from "./tours/trainingAuthor";
export { ADS_GUIDANCE_TOUR, ADS_GUIDANCE_TOUR_ID } from "./tours/adsGuidance";
export { ADMIN_ORG_TOUR, ADMIN_ORG_TOUR_ID } from "./tours/adminOrg";
export { ADMIN_MEMBERS_TOUR, ADMIN_MEMBERS_TOUR_ID } from "./tours/adminMembers";
export { MFG_INVENTORY_TOUR, MFG_INVENTORY_TOUR_ID } from "./tours/mfgInventory";
export { MFG_PLANTS_UNITS_TOUR, MFG_PLANTS_UNITS_TOUR_ID } from "./tours/mfgPlantsUnits";
export { OPS_PAPERWORK_TOUR, OPS_PAPERWORK_TOUR_ID } from "./tours/opsPaperwork";
export { RTO_TERMS_TOUR, RTO_TERMS_TOUR_ID } from "./tours/rtoTerms";
export { LOGISTICS_ROUTES_TOUR, LOGISTICS_ROUTES_TOUR_ID } from "./tours/logisticsRoutes";
export {
  LOGISTICS_CARRIERS_TOUR,
  LOGISTICS_CARRIERS_TOUR_ID,
} from "./tours/logisticsCarriers";
export { PLATFORM_HOME_TOUR, PLATFORM_HOME_TOUR_ID } from "./tours/platformHome";

export const FIREFLY_TOUR_CATALOG: readonly FireflyTourArtifact[] = [
  LEAD_CAPTURE_TOUR,
  OPPORTUNITIES_ENTRY_TOUR,
  SALES_CONSOLE_TOUR,
  ADS_ASSISTANT_TOUR,
  CRM_HANDOFF_TOUR,
  TRAINING_PRACTICE_TOUR,
  SALES_INTAKE_TOUR,
  FORMS_FORMATS_TOUR,
  FULFILLMENT_INVENTORY_TOUR,
  FULFILLMENT_INTAKE_TOUR,
  KNOWLEDGEBASE_TOUR,
  KB_AUTHOR_TOUR,
  LOCATION_TOOLS_TOUR,
  AI_PROMPTING_TOUR,
  TRAINING_AUTHOR_TOUR,
  ADS_GUIDANCE_TOUR,
  ADMIN_ORG_TOUR,
  ADMIN_MEMBERS_TOUR,
  MFG_INVENTORY_TOUR,
  MFG_PLANTS_UNITS_TOUR,
  OPS_PAPERWORK_TOUR,
  RTO_TERMS_TOUR,
  LOGISTICS_ROUTES_TOUR,
  LOGISTICS_CARRIERS_TOUR,
  PLATFORM_HOME_TOUR,
];

const BY_ID = new Map(FIREFLY_TOUR_CATALOG.map((t) => [t.id, t]));

export function getFireflyTourById(tourId: string): FireflyTourArtifact | null {
  return BY_ID.get(tourId.trim()) ?? null;
}
